// angular
import { Routes } from '@angular/router';
// components
import { LayoutComponent } from '@app/layout/layout.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { HomeComponent } from './+home/home.component';
// temporary: disable auctions section quick order section
// import { QuickOrderFormComponent } from '@quick-order/quick-order-form/quick-order-form.component';

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('@home/home.component').then(m => m.HomeComponent),
        data: { titleKey: 'wejoiner', hiddenTopSearchBar: true },
      },
      {
        path: 'auctions',
        loadChildren: () =>
          import('@auctions/auctions.routes').then(m => m.AuctionsRoutes),
      },
      {
        path: 'projects',
        loadChildren: () =>
          import('@projects/projects.routes').then(m => m.ProjectsRoutes),
      },
      {
        path: 'tenders',
        loadChildren: () =>
          import('@tenders/tenders.routes').then(m => m.TendersRoutes),
      },
      {
        path: 'products',
        loadChildren: () =>
          import('@products/products.routes').then(m => m.ProductsRoutes),
      },
      {
        path: 'categories',
        loadChildren: () =>
          import('@categories/categories.routes').then(m => m.CategoriesRoutes),
      },
      {
        path: 'industries',
        redirectTo: 'solutions',
        pathMatch: 'prefix',
      },
      {
        path: 'solutions',
        loadChildren: () =>
          import('@suppliers/suppliers.routes').then(m => m.SuppliersRoutes),
      },

      // temporary : this route commented temporary
      // {
      //   path: 'blogs',
      //   loadChildren: () =>
      //     import('@blogs/blogs.routes').then(m => m.BlogsRoutes),
      // },

      {
        path: 'help',
        loadChildren: () => import('@help/help.routes').then(m => m.HelpRoutes),
      },
      {
        path: 'people',
        loadChildren: () =>
          import('@app/+solutions/solutions.routes').then(
            m => m.SolutionsRoutes
          ),
        data: { titleKey: 'routes.portfolio' },
      },
      {
        path: 'about',
        loadChildren: () =>
          import('@about/about.routes').then(m => m.AboutRoutes),
      },
      {
        path: 'legal',
        loadChildren: () =>
          import('@app/+legal/legal.routes').then(m => m.LegalRoutes),
      },
      {
        path: 'contact',
        loadComponent: () =>
          import('@app/+contact/contact-page.component').then(
            m => m.ContactPageComponent
          ),
        data: { titleKey: 'routes.contactUs' },
      },
      {
        path: 'team',
        loadComponent: () =>
          import('@app/+team/team-page.component').then(
            m => m.TeamPageComponent
          ),
        data: { titleKey: 'routes.team' },
      },
      {
        path: 'profile',
        loadChildren: () =>
          import('@profile/profile.routes').then(m => m.ProfileRoutes),
        data: { hiddenTopSearchBar: true },
      },
      // temporary: disable auctions section quick order section
      // {
      //   path: 'quick-orders',
      //   loadChildren: () =>
      //     import('@quick-order/quick-order.routes').then(
      //       m => m.QuickOrderRoutes
      //     ),
      // },
      // temporary: disable auctions section quick order section
      // {
      //   path: 'qo',
      //   component: QuickOrderFormComponent,
      //   data: { titleKey: 'routes.quickOrders' },
      // },
      {
        path: 'search-results',
        loadChildren: () =>
          import('@app/+search/search-results.routes').then(
            m => m.SearchRoutes
          ),
      },
      // temporary : this route commented temporary
      // {
      //   path: 'explore',
      //   loadChildren: () =>
      //     import('@explores/explores.routes').then((m) => m.ExploresRoutes),
      // },
    ],
  },
  {
    path: '404',
    component: NotFoundComponent,
    data: { titleKey: 'routes.notFound' },
  },
  {
    path: '**',
    component: NotFoundComponent,
    data: { titleKey: 'routes.notFound' },
  },
];
